module.exports = __webpack_public_path__ + "static/media/galleryImg13.68d098b8.jpg";